import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { IconButton } from 'material-ui';
import ControlPointIcon from 'material-ui/svg-icons/image/control-point';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';

import { changePort } from 'actions/regions/ports';
import { Field, formValueSelector } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import { email } from 'redux-form-validators';
import { formName } from 'data/formNames';

const styles = {
    textField: {
        floatingLabelStyle: { fontSize: '12px' },
    },
    icon: {
        color: 'rgb(0, 188, 212)',
    },
};

function Emails({ fields }) {
    const addEmail = useCallback(() => {
        fields.push('');
    }, [fields]);

    return (
        <Fragment>
            {
                fields.map((field, index) => (
                    <div className="row" key={index}>
                        <div className="col-xs-10">
                            <Field
                                component={TextField}
                                name={field}
                                floatingLabelText='Email company'
                                floatingLabelStyle={styles.textField.floatingLabelStyle}
                                fullWidth
                                validate={email()}
                            />
                        </div>
                        <div className="col-xs-2 center-xs middle-xs">
                            {
                                index === 0 ?
                                    <IconButton
                                        iconStyle={styles.icon}
                                        onClick={addEmail}
                                    >
                                        <ControlPointIcon />
                                    </IconButton>
                                    :
                                    <IconButton
                                        iconStyle={styles.icon}
                                        onClick={() => {
                                            fields.remove(index);
                                        }}
                                    >
                                        <ContentRemoveIcon />
                                    </IconButton>
                            }
                        </div>
                    </div>
                ))
            }
        </Fragment>
    );
}

Emails.propTypes = {
    fields: PropTypes.object.isRequired,
};

const selector = formValueSelector(formName.portUpdate);
export default connect(
    (state, ownProps) => ({
        ...ownProps,
        serviceProviders: selector(state, 'serviceProviders'),
    }),
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(Emails);



// WEBPACK FOOTER //
// ./app/components/Regions/Port/ServiceProviders/Emails.jsx